import styles from "./IconStyles.module.css";

/**
 * Icon for redo action used in the editor toolbar.
 *
 * @param props - Destructured parameter object
 * @param props.onClick - Click handler invoked when the redo icon is activated.
 * @param props.fill - Colour theme for the icon; accepts `"gray"` or `"black"`.
 */
export const RedoBtn = ({ onClick, fill }: { onClick: () => void; fill: "gray" | "black" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="16"
    viewBox="0 0 24 24"
    width="16"
    className={styles.redoBtn}
    fill={fill}
    onClick={() => onClick()}
    aria-label="Redo"
  >
    <path
      d="M0 0h24v24H0z"
      fill="none"
    />
    <path d="M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16c1.05-3.19 4.05-5.5 7.6-5.5 1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z" />
  </svg>
);

RedoBtn.displayName = "RedoBtn";
